import React, { useState } from "react";
import styled from 'styled-components'
import { NavLink, Link } from "react-router-dom";
import { navData } from "./navData";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import styles from "./sidenav.module.css";
import OTIS_Logo from '../../OTIS_BIG.D.svg';
import { getMsalLogout } from "../../authConfig";
import { getUserRole } from "../common/helpers";
import { ReactComponent as Help } from "../../icons-svg/icons/Help.svg"


export const getUserDetails = () => {
  const { idTokenClaims = {}, username } = JSON.parse(localStorage.getItem('user_profile')) || {};
  const { name = 'NA' } = idTokenClaims;
  const reg = /(\w+)(.|,|,\s)(\w+)/;
  const splitName = name.match(reg) || [];
  const firstName = splitName[3];
  const lastName = splitName[1];
  const userInitials = (typeof(firstName) === "string" && firstName.length > 0 ? firstName.charAt(0) : "N") + (typeof(lastName) === "string" && lastName.length > 0 ? lastName.charAt(0) : "A");
  const userFullName = firstName + " " + lastName;

  return {
    userInitials,
    userFullName,
    username
  }
}

const SideArrows = styled.button`
  align-self: center;
  align-self: flex-start; 
  justify-self: flex-end;
  color: #ffffff;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 0px;
  padding: 0px;
  margin-left: 0px;
  flex-direction: ${props => props.isOpen ? "row" : "column-reverse"};
  z-index: 9;
  svg{
    width: 50px;
    height: 50px;
  }

`

export default function Sidenav(props) {
  const { role_id } = props;
  const { userInitials, userFullName } = getUserDetails();
  
  const [open, setOpen] = useState(true)
  const toggleOpen = () => {
    setOpen(!open)
  }

  const filterNavData = (navData) => {
    if(getUserRole(role_id) === "Viewer" || getUserRole(role_id) === "RM") {
      return navData.filter((list) => list.id !== 3);
    } else if (getUserRole(role_id) === "FM") {
      return navData.filter((list) => list.id === 1);
    } else{
      return navData
    }
  }
    
  return (
      <div className={open ? styles.sidenav : styles.sidenavClosed}>
        <div className={styles.links}>
          <Link to="/">
            <div className="text-center p-2">
              <img style={{ 'height': '17px', 'marginBottom':'18px', 'marginTop': '10px' }} src={OTIS_Logo} alt="OTIS HOMEPAGE"/>
              </div>
              </Link>
          {filterNavData(navData).map(item => {
            return <NavLink style={({ isActive }) => 
            (isActive ? {backgroundColor: '#4d4d4d'} : {backgroundColor: '#1F1F1F'})} key={item.id} className={open?styles.sideitemOpen: styles.sideitemClose} to={item.link}>
              {item.icon}
              <span className={open ? styles.linkText : styles.linkTextClosed}>{item.text}</span>
            </NavLink>
          })}
        </div>
                <div className={open ? styles.profileContainer : styles.profileContainerClose}>
                    <Link to="https://servicenow.otis.com/esc" target="_blank" className={open ? styles.helpIconOpen : styles.helpIconClose} title="Open a Ticket on Servicenow">   
          <div>
          <Help/>
          </div>
           </Link>
          <div className={open ? styles.profileSection : styles.profileSectionClose}>
            <div className={ open ? styles.profileAvatarOpen : styles.profileAvatarClose }>{userInitials}</div>
            {open && <div className={styles.profileDetail}>
              <p className={styles.userName}>{userFullName}</p>
              <div className={styles.logoutSection}>
                <p className={styles.roleName}>{getUserRole(role_id)}</p>
                <button className={styles.logout} onClick={getMsalLogout}>(Logout)</button>
              </div>
            </div>}
            <SideArrows onClick={toggleOpen} className={open ? styles.open : styles.close} isOpen={open}>
            {open ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
          </SideArrows>
          </div>
        </div>
      </div>
  )
}